export const TIER_PRIORITY = {
  spotlight: 3,
  featured: 2,
  basic: 1,
};

export function getTierKey(listing) {
  return listing?.tierInfo?.key || listing?.tier || "basic";
}

export function getTierName(listing) {
  return listing?.tierInfo?.name || getTierKey(listing);
}

export function hasFeature(listing, featureKey) {
  const features = listing?.features;

  // Graceful fallback for legacy/partial API responses.
  if (!features || typeof features !== "object") {
    return true;
  }

  return features[featureKey] === true;
}

export function compareListingsByTierPriority(a, b) {
  const aPriority = TIER_PRIORITY[getTierKey(a)] || 0;
  const bPriority = TIER_PRIORITY[getTierKey(b)] || 0;

  return bPriority - aPriority;
}

export function getTierBadgeConfig(listing) {
  const tierKey = getTierKey(listing);

  if (tierKey === "spotlight") {
    return {
      label: "Spotlight",
      className: "badge",
      style: {
        backgroundColor: 'var(--badge-spotlight-color)',
        color: 'var(--badge-spotlight-text-color)',
      },
    };
  }

  if (tierKey === "featured") {
    return {
      label: "Featured",
      className: "badge",
      style: {
        backgroundColor: 'var(--badge-featured-color)',
        color: 'var(--badge-featured-text-color)',
      },
    };
  }

  return null;
}
